import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function ProtectedAdminRoute({ children }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('isAdmin') !== 'true') {
      navigate('/admin/login');
    }
  }, [navigate]);

  return localStorage.getItem('isAdmin') === 'true' ? children : null;
}

export default ProtectedAdminRoute;